import React, { useCallback } from "react";
import styles from "./benefits.module.scss";
import { cn } from "utils";
import Input from "components/Input";
import Select from "components/Select";
import SubmitButton from "components/SubmitButton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { CompanyBenefitInputs, companyBenefitSchema } from "./const";

const AddEditCompanyBenefit = () => {
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(companyBenefitSchema)
    });

    const onSubmit = useCallback((values)=> {
        console.log("values", values);
    }, [])

    return (
        <form
            className={cn("container-spacing pt-3 pb-5", styles.addEditCompanyBenefit)}
            onSubmit={handleSubmit(onSubmit)}
        >
            <h3 className={cn("title mt-2")}>Add Company Benefit</h3>
            <div>
                <div>
                    <p className={cn("info-title mt-3")}>General Information</p>
                    <div className={cn("container-fluid padding-0")}>
                        <div className={cn("row")}>
                            <div className="col-lg-8 col-12">
                                <Input
                                    label="Description*"
                                    fullWidth
                                    variant="flat"
                                    {...register(CompanyBenefitInputs.DESCRIPTION)}
                                    error={!!errors[CompanyBenefitInputs.DESCRIPTION]}
                                    errorText={errors[CompanyBenefitInputs.DESCRIPTION]?.message}
                                />
                            </div>
                        </div>
                        <div className={cn("row g-3 mt-2")}>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Start Date"
                                    fullWidth
                                    variant="flat"
                                    type="date"
                                    {...register(CompanyBenefitInputs.START_DATE)}
                                    error={!!errors[CompanyBenefitInputs.START_DATE]}
                                    errorText={errors[CompanyBenefitInputs.START_DATE]?.message}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="End Date"
                                    fullWidth
                                    variant="flat"
                                    type="date"
                                    {...register(CompanyBenefitInputs.END_DATE)}
                                    error={!!errors[CompanyBenefitInputs.END_DATE]}
                                    errorText={errors[CompanyBenefitInputs.END_DATE]?.message}
                                />
                            </div>
                            <div className="col-lg-8 col-12">
                                <Select
                                    label="Type*"
                                    fullWidth
                                    options={[]}
                                    {...register(CompanyBenefitInputs.TYPE)}
                                    error={!!errors[CompanyBenefitInputs.TYPE]}
                                    errorText={errors[CompanyBenefitInputs.TYPE]?.message}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <p className={cn("info-title mt-3")}>Contribution Information</p>
                    <div className={cn("container-fluid padding-0")}>
                        <div className={cn("row")}>
                            <div className="col-lg-8 col-12">
                                <Select
                                    label="Contribution Period"
                                    fullWidth
                                    options={[]}
                                    {...register(CompanyBenefitInputs.CONTRIBUTION_PERIOD)}
                                    error={!!errors[CompanyBenefitInputs.CONTRIBUTION_PERIOD]}
                                    errorText={errors[CompanyBenefitInputs.CONTRIBUTION_PERIOD]?.message}
                                />
                            </div>
                        </div>
                        <div className={cn("row g-3 mt-2")}>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Company Contribution*"
                                    fullWidth
                                    variant="flat"
                                    {...register(CompanyBenefitInputs.COMPANY_CONTRIBUTION_1)}
                                    error={!!errors[CompanyBenefitInputs.COMPANY_CONTRIBUTION_1]}
                                    errorText={errors[CompanyBenefitInputs.COMPANY_CONTRIBUTION_1]?.message}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Company Contribution*"
                                    fullWidth
                                    variant="flat"
                                    {...register(CompanyBenefitInputs.COMPANY_CONTRIBUTION_2)}
                                    error={!!errors[CompanyBenefitInputs.COMPANY_CONTRIBUTION_2]}
                                    errorText={errors[CompanyBenefitInputs.COMPANY_CONTRIBUTION_2]?.message}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5">
                    <SubmitButton
                        submitText="Add Benefit"
                    />
                </div>
            </div>
        </form>
    )
}

export default AddEditCompanyBenefit;